export var NotificationCategory;
(function (NotificationCategory) {
    NotificationCategory["OrderCreated"] = "order_created";
    NotificationCategory["FBCatalogSync"] = "fb_catalog_sync";
    NotificationCategory["NegativeSentimentReminder"] = "negative_sentiment_reminder";
})(NotificationCategory || (NotificationCategory = {}));
